
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { Card } from '../../components/base/Card';
import { SectionHeader } from '../../components/base/SectionHeader';

export default function AboutPage() {
  const timeline = [
    { year: '1999', event: 'Birsöz İnşaat kuruldu' },
    { year: '2003', event: 'İlk büyük konut projesi tamamlandı' },
    { year: '2008', event: 'Ticari proje portföyü genişletildi' },
    { year: '2015', event: 'Sürdürülebilir inşaat sertifikası alındı' },
    { year: '2020', event: '100+ proje tamamlandı' },
    { year: '2024', event: 'Yeni nesil akıllı binalar' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-24 pb-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-[28px] font-bold text-[#0e3851] mb-4">
              Kurumsal Profil
            </h1>
            <p className="text-[16px] text-gray-600 max-w-3xl mx-auto">
              25 yıllık deneyimimizle inşaat sektöründe güvenilir bir marka olarak, 
              kaliteli yaşam alanları inşa etmeye devam ediyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Kurumsal Özet */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <SectionHeader 
                title="Birsöz İnşaat Hakkında"
                subtitle="Güvenilir inşaat çözümleri ile sektörde öncü konumdayız"
                className="mb-6"
              />
              <div className="space-y-4 text-[15px] text-gray-600">
                <p>
                  1999 yılında kurulan Birsöz İnşaat, çeyrek asırlık deneyimi ile 
                  inşaat sektöründe güvenilir bir marka haline gelmiştir. Kaliteli 
                  malzeme kullanımı, zamanında teslim ve müşteri memnuniyeti odaklı 
                  yaklaşımımızla sektörde fark yaratmaktayız.
                </p>
                <p>
                  Konut projelerinden ticari yapılara, kentsel dönüşümden 
                  sürdürülebilir inşaat çözümlerine kadar geniş bir yelpazede 
                  hizmet vermekteyiz. Her projemizde modern teknoloji ve 
                  geleneksel ustalığı harmanlayarak, yaşam kalitesini artıran 
                  mekanlar yaratıyoruz.
                </p>
                <p>
                  100'den fazla başarılı projeye imza atan firmamız, müşteri 
                  odaklı yaklaşımı ve kalite standartlarından ödün vermeme 
                  ilkesiyle sektörde saygın bir konuma sahiptir.
                </p>
              </div>
            </div>
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/7a5815b1d6c27caff12c9fa132478bb8.jpg"
                alt="Birsöz İnşaat Ofis"
                className="w-full h-80 object-cover rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Tarihçe */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeader 
            title="Tarihçemiz"
            subtitle="25 yıllık başarı hikayemizin önemli dönüm noktaları"
            centered
            className="mb-12"
          />
          
          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-[#0e3851]"></div>
            <div className="space-y-8">
              {timeline.map((item, index) => (
                <div key={index} className={`flex items-center ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                  <div className={`w-1/2 ${index % 2 === 0 ? 'pr-8 text-right' : 'pl-8 text-left'}`}>
                    <Card>
                      <div className="text-[18px] font-bold text-[#0e3851] mb-2">{item.year}</div>
                      <div className="text-[15px] text-gray-600">{item.event}</div>
                    </Card>
                  </div>
                  <div className="relative z-10">
                    <div className="w-4 h-4 bg-[#0e3851] rounded-full border-4 border-white shadow-lg"></div>
                  </div>
                  <div className="w-1/2"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* İstatistikler */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-[32px] font-bold text-[#0e3851] mb-2">25+</div>
              <div className="text-[15px] text-gray-600">Yıllık Deneyim</div>
            </div>
            <div className="text-center">
              <div className="text-[32px] font-bold text-[#0e3851] mb-2">100+</div>
              <div className="text-[15px] text-gray-600">Tamamlanan Proje</div>
            </div>
            <div className="text-center">
              <div className="text-[32px] font-bold text-[#0e3851] mb-2">500K+</div>
              <div className="text-[15px] text-gray-600">m² İnşaat Alanı</div>
            </div>
            <div className="text-center">
              <div className="text-[32px] font-bold text-[#0e3851] mb-2">98%</div>
              <div className="text-[15px] text-gray-600">Müşteri Memnuniyeti</div>
            </div>
          </div>
        </div>
      </section>

      {/* İş Güvenliği */}
      <section className="py-16 bg-[#0e3851] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-[22px] font-semibold mb-4">İş Güvenliği ve Kalite Politikamız</h2>
            <p className="text-[16px] text-gray-300 max-w-4xl mx-auto">
              Tüm projelerimizde iş güvenliği önceliğimizdir. ISO 9001 kalite yönetim sistemi 
              ve OHSAS 18001 iş sağlığı güvenliği standartlarına uygun çalışarak, 
              hem çalışanlarımızın hem de müşterilerimizin güvenliğini sağlıyoruz.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
